import SmoothScroll from "smooth-scroll"

let smoption = {
    updateURL: false,
    speed: 300,
    easing: 'linear'
}

let scroll = new SmoothScroll('a[href*="#"]', smoption);